import React, { useState } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import PDFViewer from "../PDFViewer/PDFViewer";
import WebViewerBackend from "../../backends/WebViewer";
import {
  apiUrl,
  pdftronServerUrl,
  loadDocumentUrl,
} from "../../lib/axios-client";
import security from "../../services/Security";
import httpClient from "../../lib/HttpClient";
import Tooltip from "../Common/Tooltip";
import stampTool from "../../pdf/tools/Stamp";

import GreenCheckmark from "../../images/icons/svg/green-checkmark.svg";
import Pencil from "../../images/icons/svg/pencil.svg";

/* UI Kit */
import { UikInput, UikButton } from "@uik";
import "@uik/styles.css";
import styles from "./PDFTReference.module.scss";

class Menu extends React.Component {
  state = {
    showDropdown: false,
    editReferenceLabelOpen: false,
    editAnnotationLabelOpen: false,
  };

  onClick = () => {
    this.setState({
      showDropdown: !this.state.showDropdown,
      userRole: security.getUserRole(),
      pinToolsLoaded: false,
    });
  };

  render() {
    let color = "#ADB5BD";
    if (this.state.showDropdown) {
      color = "#1A7285";
    }
    return (
      <div>
        <div
          style={{
            color,
            cursor: "pointer",
            fontSize: "10px",
            marginRight: "4px",
            marginLeft: "4px",
          }}
          onClick={this.onClick}
        >
          &#9679;&#9679;&#9679;
        </div>
        {this.state.showDropdown && (
          <div
            style={{
              position: "absolute",
              top: "37px",
              right: 0,
              backgroundColor: "white",
              width: "192px",
              borderRadius: "4px",
              zIndex: "99",
            }}
          >
            <div
              style={{
                color: "#3e3f42",
                padding: "8px 16px",
                cursor: "pointer",
              }}
              onClick={() => {
                this.props.downloadDocument();
                this.setState({ showDropdown: false });
              }}
            >
              Download
            </div>
            {this.state.userRole !== "viewer" && (
              <div>
                <div
                  style={{
                    height: "1px",
                    background: "#EAEDF3",
                  }}
                ></div>
                <div
                  style={{
                    color: "#3e3f42",
                    padding: "8px 16px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    this.props.showDeleteModal();
                    this.setState({ showDropdown: false });
                  }}
                >
                  Delete
                </div>
                <div
                  style={{
                    height: "1px",
                    background: "#EAEDF3",
                  }}
                ></div>
                <div
                  style={{
                    color: "#3e3f42",
                    padding: "8px 16px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    this.props.showRenameModal();
                    this.setState({ showDropdown: false });
                  }}
                >
                  Rename
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

class PDFTReference extends React.Component {
  constructor(props) {
    super();

    this.viewer = React.createRef();
    this.documentViewer = null;
    this.annotationManager = null;
    this.instance = null;
    this.annotations = null;

    this.state = {
      webViewerLoaded: false,
      selectedQuads: null,
      currentPageIndex: null,
      currentAnnotation: null,
      currentAnnotationXfdf: null,
      currentAnnotationText: null,
      coordinates: null,
      referenceLabel: null,
      referenceDocumentLabel: null,
      creatingNewAnnotation: false,
      externalAnnotationSelected: false,
      pinDropReferenceCreated: false,
      outsideAnnotations: [],
      referenceAnnotations: [],
    };
  }

  handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    let referenceLabelInput = document.getElementById("referenceLabelInput");
    let referenceDocumentLabelInput = document.getElementById(
      "referenceDocumentLabelInput"
    );

    if (
      target.name === "referenceDocumentLabel" &&
      target.value.trim() !== ""
    ) {
      let refDocLabelExistsError = document.getElementById(
        "refDocLabelExistsError"
      );
      refDocLabelExistsError.style.display = "none";

      let refDocLabelError = document.getElementById("refDocLabelError");
      refDocLabelError.style.display = "none";

      referenceDocumentLabelInput.style.borderColor = "#D6DCE8";
    }

    if (target.name === "referenceLabel" && target.value.trim() !== "") {
      const refLabelError = document.getElementById("refLabelError");
      const refLabelEmptyError = document.getElementById("refLabelEmptyError");
      refLabelError.style.display = "none";
      refLabelEmptyError.style.display = "none";

      referenceLabelInput.style.borderColor = "#D6DCE8";
    }
  };

  isImportedAnnotation = (annot) => {
    if (typeof annot.isInternal() !== "undefined") {
      return true;
    }
  };

  checkIfReference = (annot) => {
    let isReference = this.props.references.find((reference) => {
      return reference.xfdf_highlight_id === annot.Id;
    });
    return isReference;
  };

  pinToolsGroupButtonClicked = () => {
    this.instance.UI.setToolMode("PinReferenceTool");
    const pinToolsGroupButton =
      this.instance.UI.iframeWindow.document.querySelector(
        '[data-element="pinToolsGroupButton"]'
      );

    if (
      pinToolsGroupButton &&
      pinToolsGroupButton.classList.contains("active")
    ) {
      pinToolsGroupButton.classList.remove("active");
      this.instance.UI.setToolMode("AnnotationEdit");
    } else {
      if (pinToolsGroupButton) {
        pinToolsGroupButton.classList.add("active");
      }
    }
  };

  shouldComponentUpdate = () => {
    return false;
  };

  handleSave = (e) => {
    e.preventDefault();

    if (this.validateInput()) {
      // Editing an existing reference's "annotation id" field. The change is
      // persisted through handleChangeSubmission() (the same path used by the
      // inline checkmark), not by creating a new annotation via
      // confirmReference() — there is no text selection to build one from.
      // Guarded with !creatingNewAnnotation so the create flow (where the user
      // can also open the annotation-id field via the pencil) still falls
      // through to confirmReference() and actually creates the annotation.
      if (
        this.state.editAnnotationLabelOpen &&
        !this.state.creatingNewAnnotation
      ) {
        this.handleChangeSubmission();
        this.hideLabellerModal();
        return;
      }

      // Check and see if we have the Reference ID in edit mode
      // If we are in edit mode, initiate change confirmation.
      if (this.state.editReferenceLabelOpen) {
        this.handleConfirmRefDocLabel();
      } else {
        this.hideLabellerModal();
      }
      if (this.props.linkingReference && !this.state.creatingNewAnnotation) {
        this.confirmExistingReference();
      } else {
        this.confirmReference();
      }
    }
  };

  validateInput = () => {
    let refDocLabelError = document.getElementById("refDocLabelError");
    let refDocLabelExistsError = document.getElementById(
      "refDocLabelExistsError"
    );
    let refLabelEmptyError = document.getElementById("refLabelEmptyError");
    let refLabelError = document.getElementById("refLabelError");
    let referenceLabelInput = document.getElementById("referenceLabelInput");
    let referenceDocumentLabelInput = document.getElementById(
      "referenceDocumentLabelInput"
    );

    let referenceDocumentLabel =
      this.props.references.length > 0
        ? this.props.references[0].document.reference_document_label
        : null;

    let refDocLabelExists = false;

    this.props.sharedReferences.shared_references.map((ref) => {
      if (
        ref.reference_document_label &&
        ref.reference_document_label.trim().toLowerCase() ===
          referenceDocumentLabelInput.value.trim().toLowerCase()
      ) {
        if (this.props.referenceDocumentLabel) {
          if (
            referenceDocumentLabelInput.value.trim().toLowerCase() !==
            this.props.referenceDocumentLabel.trim().toLowerCase()
          ) {
            refDocLabelExists = true;
          }
        } else {
          refDocLabelExists = true;
        }
      }
    });

    let refLabelExists = false;

    let selectedReference = null;

    if (this.props.currentRefLabel) {
      if (referenceLabelInput.value === this.props.currentRefLabel) {
        refLabelError.style.display = "block";
        referenceLabelInput.style.borderColor = "#e98b86";

        return false;
      }
    }

    this.props.references.map((ref) => {
      if (
        ref.label &&
        ref.label.trim().toLowerCase() ===
          referenceLabelInput.value.trim().toLowerCase()
      ) {
        refLabelExists = true;
      }
      if (this.state.currentAnnotation) {
        if (ref.xfdf_highlight_id === this.state.currentAnnotation.Id) {
          selectedReference = ref;
        }
      }
    });

    let refDocLabelEmpty = false;
    let refLabelEmpty = false;

    if (referenceDocumentLabelInput.value.trim() === "") {
      refDocLabelEmpty = true;
    }
    if (referenceLabelInput.value.trim() === "") {
      refLabelEmpty = true;
    }

    if (selectedReference) {
      if (
        refLabelExists &&
        selectedReference.label !== referenceLabelInput.value.trim()
      ) {
        refLabelError.style.display = "block";
        referenceLabelInput.style.borderColor = "#e98b86";

        return false;
      } else if (refDocLabelEmpty) {
        refDocLabelError.style.display = "block";
        referenceDocumentLabelInput.style.borderColor = "#e98b86";

        return false;
      } else if (refLabelEmpty) {
        refLabelEmptyError.style.display = "block";
        referenceLabelInput.style.borderColor = "#e98b86";

        return false;
      } else if (
        refDocLabelExists &&
        selectedReference.document.reference_document_label !==
          referenceDocumentLabelInput.value.trim()
      ) {
        refDocLabelExistsError.style.display = "block";
        referenceDocumentLabelInput.style.borderColor = "#e98b86";

        return false;
      } else {
        return true;
      }
    } else {
      if (refLabelExists) {
        refLabelError.style.display = "block";
        referenceLabelInput.style.borderColor = "#e98b86";

        return false;
      } else if (refDocLabelEmpty) {
        refDocLabelError.style.display = "block";
        referenceDocumentLabelInput.style.borderColor = "#e98b86";

        return false;
      } else if (refLabelEmpty) {
        refLabelEmptyError.style.display = "block";
        referenceLabelInput.style.borderColor = "#e98b86";

        return false;
      } else if (
        refDocLabelExists &&
        referenceDocumentLabel !== referenceDocumentLabelInput.value.trim()
      ) {
        refDocLabelExistsError.style.display = "block";
        referenceDocumentLabelInput.style.borderColor = "#e98b86";

        return false;
      } else {
        return true;
      }
    }
  };

  updateHighlightColor = (annot) => {
    const color = new this.instance.Core.Annotations.Color(122, 106, 141);
    this.annotationManager.setAnnotationStyles(annot, () => ({
      StrokeColor: color,
      FillColor: color,
      Opacity: "0.5",
    }));
  };

  loadAnnotations = () => {
    let getDocId = this.props.docId;

    if (this.props.references) {
      this.setState({
        referenceDocumentLabel:
          this.props.references[0] !== undefined
            ? this.props.references[0].document.reference_document_label
            : null,
      });

      this.props.references.forEach((reference) => {
        if (reference.xfdf_highlight_id) {
          this.annotationManager.importAnnotationCommand(
            reference.xfdf_highlight_string
          );
        }
      });

      this.annotationManager.drawAnnotationsFromList(
        this.annotationManager.getAnnotationsList()
      );
    }
  };

  componentDidMount = () => {
    const token = security.getToken();

    window.addEventListener("resize", this.onResize);

    let webViewerOptions = {
      path: "/vendor/pdf/lib",
      fullAPI: true,
      css: "/vendor/pdf/lib/ui/ReferencePDFtronStyle.css",
      disabledElements: [
        "toggleNotesButton",
        "outlinesPanelButton",
        "contextMenuPopup",
        "outlinesPanel",
        "notePopup",
        "thumbnailControl",
        "documentControl",
        "annotationContentOverlay",
        "layersPanelButton",
        "toolStylePopup",
        "highlightToolButton",
        "highlightToolButton2",
        "highlightToolButton3",
        "highlightToolButton4",
        "underlineToolButton",
        "squigglyToolButton",
        "strikeoutToolButton",
        "ellipseToolButton",
        "lineToolButton",
        "arrowToolButton",
        "polylineToolButton",
        "polygonToolButton",
        "cloudToolButton",
        "calloutToolButton",
        "stampToolButton",
        "fileAttachmentToolButton",
        "cropToolButton",
        "freeHandToolButton",
        "freeHandToolButton2",
        "freeHandToolButton3",
        "freeHandToolButton4",
        "rectangleToolButton",
        "textPopup",
        "annotationPopup",
        "ribbons",
        "signaturePanelButton",
      ],
      licenseKey: `${process.env.REACT_APP_PDFTRON_LICENSE_KEY}`,
    };

    if (process.env.REACT_APP_WEBVIEWER_SERVER === "true") {
      webViewerOptions["pdftronServer"] = pdftronServerUrl;
    }

    this.viewer = window
      .WebViewer(
        webViewerOptions,
        document.getElementById("webViewerReference")
      )
      .then((instance) => {
        const { documentViewer, annotationManager, Annotations, PDFNet } =
          instance.Core;

        this.annotations = Annotations;
        this.instance = instance;
        this.documentViewer = documentViewer;
        this.annotationManager = annotationManager;

        let _that = this;

        // Set leftPanel
        instance.UI.setActiveLeftPanel("thumbnailsPanel");

        instance.UI.updateElement("viewControlsButton", {
          img: "/assets/svg/default-viewcontrols.svg",
        });

        instance.UI.updateElement("leftPanelButton", {
          img: "/assets/svg/default-leftsidepanel.svg",
        });

        instance.UI.updateElement("selectToolButton", {
          img: "/assets/svg/default-select.svg",
        });

        instance.UI.updateElement("zoomOutButton", {
          img: "/assets/svg/default-minus.svg",
        });

        instance.UI.updateElement("zoomInButton", {
          img: "/assets/svg/default-plus.svg",
        });

        instance.UI.updateElement("zoomOverlay", {
          img: "/assets/svg/chevron.svg",
        });

        instance.UI.updateElement("panToolButton", {
          img: "/assets/svg/default-pan.svg",
        });

        instance.UI.updateElement("searchButton", {
          img: "/assets/svg/default-magnifying-glass.svg",
        });

        // Remove headeer toolbar tools
        instance.UI.setHeaderItems(function (header) {
          header.getItems();
        });

        // Remove download option in more drop down menu
        instance.UI.disableElement("downloadButton");
        instance.UI.disableTools(["TextSelectTool", "AnnotationComment"]);

        // Load the document
        if (this.props.docId > 0) {
          instance.Core.documentViewer.loadDocument(
            `${loadDocumentUrl()}/documents/${this.props.docId}/file${
              this.props.docExtension
            }`,
            {
              customHeaders: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        }

        const getDictionary = () => {
          return validateDictionary("ABCDEFGHIJKLMNOPQRSTUVWXYZ");

          function validateDictionary(dictionary) {
            for (let i = 0; i < dictionary.length; i++) {
              if (
                dictionary.indexOf(dictionary[i]) !==
                dictionary.lastIndexOf(dictionary[i])
              ) {
                console.log(
                  "Error: The dictionary in use has at least one repeating symbol:",
                  dictionary[i]
                );
                return undefined;
              }
            }
            return dictionary;
          }
        };

        const numberToEncodedLetter = (number) => {
          //Takes any number and converts it into a base (dictionary length) letter combo.
          //It converts any numerical entry into a positive integer.
          if (isNaN(number)) {
            return undefined;
          }
          number = Math.abs(Math.floor(number));

          const dictionary = getDictionary();
          let index = number % dictionary.length;
          let quotient = number / dictionary.length;
          let result;

          if (number <= dictionary.length) {
            return numToLetter(number);
          } //Number is within single digit bounds of our encoding letter alphabet

          if (quotient >= 1) {
            //This number was bigger than our dictionary, recursively perform this function until we're done
            if (index === 0) {
              quotient--;
            } //Accounts for the edge case of the last letter in the dictionary string
            result = numberToEncodedLetter(quotient);
          }

          if (index === 0) {
            index = dictionary.length;
          } //Accounts for the edge case of the final letter; avoids getting an empty string

          return result + numToLetter(index);

          function numToLetter(number) {
            //Takes a letter between 0 and max letter length and returns the corresponding letter
            if (number > dictionary.length || number < 0) {
              return undefined;
            }
            if (number === 0) {
              return "A";
            } else {
              return dictionary.slice(number - 1, number);
            }
          }
        };

        const getMouseLocation = (e) => {
          const scrollElement = document.getElementById("webViewerReference");
          let scrollLeft = scrollElement.scrollLeft || 0;
          let scrollTop = scrollElement.scrollTop - 30 || 0;

          return {
            x: e.pageX + scrollLeft,
            y: e.pageY + scrollTop,
          };
        };

        const renderLabellerModal = (
          positionY,
          scrollTop,
          referenceDocumentLabel,
          referenceLabel
        ) => {
          var modal = {
            dataElement: "referenceLabellerCustomModalContainer",
            disableBackdropClick: true,
            disableEscapeKeyDown: true,

            render: function renderCustomModal() {
              let referenceLabellerContainer = document.getElementById(
                "referenceLabellerContainer"
              );
              // referenceLabellerContainer.style.left = "80";

              if (scrollTop) {
                referenceLabellerContainer.style.top =
                  positionY + scrollTop + "px";
              } else {
                referenceLabellerContainer.style.top = positionY + "px";
              }

              let referenceDocumentLabelInput = document.getElementById(
                "referenceDocumentLabelInput"
              );
              referenceDocumentLabelInput.value = referenceDocumentLabel;

              let referenceLabelInput = document.getElementById(
                "referenceLabelInput"
              );
              referenceLabelInput.value = referenceLabel;

              referenceLabellerContainer.style.display = "table";

              if (!referenceDocumentLabel) {
                referenceDocumentLabelInput.style.background = "white";
                referenceDocumentLabelInput.disabled = false;

                referenceLabelInput.style.background = "white";
                referenceLabelInput.disabled = false;

                let refLabelPencilIcon =
                  document.getElementById("refLabelPencilIcon");
                refLabelPencilIcon.style.display = "none";

                let refDocLabelPencilIcon = document.getElementById(
                  "refDocLabelPencilIcon"
                );
                refDocLabelPencilIcon.style.display = "none";
              } else {
                referenceLabelInput.style.background = "white";
                referenceLabelInput.disabled = false;

                let refLabelPencilIcon =
                  document.getElementById("refLabelPencilIcon");
                refLabelPencilIcon.style.display = "none";
              }
            },
          };
          instance.UI.addCustomModal(modal);
          instance.UI.openElements([modal.dataElement]);
        };

        instance.Core.documentViewer.addEventListener("mouseLeftUp", (e) => {
          _that.setState({
            coordinates: getMouseLocation(e),
          });
        });

        instance.Core.documentViewer
          .getTool("TextSelect")
          .addEventListener("selectionComplete", (startQuad, allQuads) => {
            if (!this.props.approved && !this.props.readOnly) {
              let pageRefCount = 0;
              let referenceDocumentLabel = _that.state.referenceDocumentLabel
                ? _that.state.referenceDocumentLabel
                : _that.props.referenceDocumentLabel;
              _that.props.references.map((ref) => {
                if (ref.page.page_number === startQuad.pageNumber) {
                  pageRefCount += 1;
                }
              });

              const letterSequence =
                pageRefCount < 26
                  ? numberToEncodedLetter(pageRefCount + 1)
                  : numberToEncodedLetter(pageRefCount);
              const referenceLabel = `pg${startQuad.pageNumber} ${letterSequence}`;

              _that.setState({
                referenceLabel,
                referenceDocumentLabel,
                creatingNewAnnotation: true,
                externalAnnotationSelected: false,
              });
              renderLabellerModal(
                _that.state.coordinates.y,
                null,
                referenceDocumentLabel,
                referenceLabel
              );
            }
          });

        // Grab the text from the highlight
        instance.Core.documentViewer.addEventListener(
          "textSelected",
          (quads, text, pageIndex) => {
            _that.setState({
              currentPageIndex: pageIndex,
              currentAnnotationText: text,
            });
          }
        );

        if (this.props.xfdfHightlightId) {
          instance.UI.disableElements(["textPopup", "annotationPopup"]);
        }

        const newCustomElement = {
          type: "customElement",
          render: () => (
            <Menu
              showRenameModal={this.props.showRenameModal}
              showDeleteModal={this.props.showDeleteModal}
              downloadDocument={this.props.downloadDocument}
            />
          ),
        };
        instance.UI.setHeaderItems(function (header) {
          header.get("searchButton").insertAfter(newCustomElement);
        });

        instance.Core.documentViewer.addEventListener("documentLoaded", () => {
          //if (process.env.REACT_APP_WEBVIEWER_SERVER === "true") {
          //  this.loadAnnotations();
          //} else {
          documentViewer
            .getDocument()
            .getDocumentCompletePromise()
            .then(async () => {
              this.loadAnnotations();
            });
          //}

          instance.UI.enableElements(["pinToolsGroupButton"]);

          if (!this.state.pinToolsLoaded) {
            const referenceStampImage =
              "data:image/svg+xml;base64,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";

            const referenceStampTool = stampTool.createStampTool(
              instance,
              referenceStampImage,
              "reference",
              null
            );

            instance.UI.registerTool({
              toolName: "PinReferenceTool",
              toolObject: referenceStampTool,
              buttonImage: "/assets/svg/reference.svg",
              buttonName: "pinReference",
              buttonGroup: "pinTools",
              tooltip: "Pin a Reference",
            });

            const pinToolsGroupButton = {
              type: "actionButton",
              dataElement: "pinToolsGroupButton",
              img: "/assets/svg/default-pin.svg",
              onClick: this.pinToolsGroupButtonClicked,
              hidden: ["mobile"],
              tooltip: "Pin a Reference",
            };

            const divider = {
              type: "divider",
              hidden: ["mobile"],
            };

            instance.UI.setHeaderItems(function (header) {
              const items = header.getItems();
              items.splice(8, 0, pinToolsGroupButton);
              header.update(items);
            });

            this.setState({ pinToolsLoaded: true });
          }
        });

        instance.Core.documentViewer.addEventListener(
          "annotationsLoaded",
          async () => {
            const annotationList =
              await this.annotationManager.getAnnotationsList();
            const referenceAnnotationList = [];
            let outsideAnnotationList = annotationList.map((annotation) => {
              if (typeof annotation.isInternal() !== "undefined") {
                return annotation;
              } else if (!this.checkIfReference(annotation)) {
                this.annotationManager.hideAnnotation(annotation);
              } else {
                referenceAnnotationList.push(annotation);
              }
            });
            this.setState({
              outsideAnnotations: outsideAnnotationList,
              referenceAnnotations: referenceAnnotationList,
            });

            this.hideExternalAnnots();
            this.props.references.forEach((reference) => {
              if (reference.xfdf_highlight_id) {
                annotationList.forEach((annot) => {
                  if (annot.Id === reference.xfdf_highlight_id) {
                    this.updateHighlightColor(annot);
                    if (
                      this.props.xfdfHightlightId &&
                      this.props.xfdfHightlightId === annot.Id
                    ) {
                      this.annotationManager.selectAnnotation(annot);
                      this.hideLabellerModal();
                      this.documentViewer.setCurrentPage(
                        reference.page.page_number
                      );
                    }
                  }
                });
              }
            });
          }
        );

        // This gets triggered when we pick comment and/or reference from the highlight TextPopup
        instance.Core.annotationManager.addEventListener(
          "annotationChanged",
          (annotations, type, info) => {
            // info.imported is true by default for annotations from pdf and annotations added by importAnnotationCommand
            if (info.imported) {
              return;
            }

            let referenceDocumentLabel = _that.state.referenceDocumentLabel;

            instance.Core.annotationManager
              .exportAnnotationCommand()
              .then((xfdf) => {
                annotations.forEach((annotation) => {
                  if (type === "add" && annotation.Subject !== "Stamp") {
                    _that.setState({
                      currentAnnotation: annotation,
                      currentAnnotationXfdf: xfdf,
                      referenceDocumentLabel,
                    });

                    _that.props.onAddReference(
                      _that.state.currentPageIndex,
                      annotation.Id,
                      xfdf,
                      _that.state.currentAnnotationText,
                      _that.state.referenceLabel,
                      referenceDocumentLabel
                    );
                  }

                  if (
                    type === "add" &&
                    annotation.Subject === "Stamp" &&
                    info.imported === false
                  ) {
                    let pageRefCount = 0;
                    const referenceDocumentLabel = _that.state
                      .referenceDocumentLabel
                      ? _that.state.referenceDocumentLabel
                      : _that.props.referenceDocumentLabel;

                    _that.props.references.map((ref) => {
                      if (ref.page.page_number === annotation.getPageNumber()) {
                        pageRefCount += 1;
                      }
                    });

                    const letterSequence =
                      pageRefCount < 26
                        ? numberToEncodedLetter(pageRefCount + 1)
                        : numberToEncodedLetter(pageRefCount);
                    const referenceLabel = `pg${annotation.getPageNumber()} ${letterSequence}`;

                    const pinDropAnnotationText = `Pindrop Reference`;

                    _that.setState({
                      currentPageIndex: annotation.getPageNumber(),
                      currentAnnotationText: pinDropAnnotationText,
                      referenceLabel,
                      referenceDocumentLabel,
                      pinDropReferenceCreated: true,
                      createdPinDropAnnotation: annotation,
                      creatingNewAnnotation: true,
                      currentAnnotationXfdf: xfdf,
                    });

                    renderLabellerModal(
                      _that.state.coordinates.y,
                      null,
                      referenceDocumentLabel,
                      referenceLabel
                    );
                  }
                });
              })
              .then(() => {
                const pinToolsGroupButton =
                  this.instance.UI.iframeWindow.document.querySelector(
                    '[data-element="pinToolsGroupButton"]'
                  );

                pinToolsGroupButton.classList.remove("active");

                this.instance.UI.setToolMode("AnnotationEdit");
              });
          }
        );

        instance.Core.annotationManager.addEventListener(
          "annotationSelected",
          async (annotationList, action) => {
            if (
              action === "selected" &&
              annotationList[0] &&
              !this.isImportedAnnotation(annotationList[0])
            ) {
              if (
                annotationList[0].Subject === "Highlight" ||
                annotationList[0].Subject === "Underline" ||
                annotationList[0].Subject === "Stamp"
              ) {
                const FitMode = instance.UI.FitMode;
                instance.UI.setFitMode(FitMode.FitPage);
                const pageIndex = annotationList[0].PageNumber - 1;
                const annotationId = annotationList[0].Id;
                let selectedReference;
                _that.props.references.map((ref) => {
                  if (ref.xfdf_highlight_id === annotationList[0].Id) {
                    selectedReference = ref;
                  }
                });

                _that.setState({
                  selectedReference,
                  selectedReferenceAnnotationId: annotationId,
                  currentAnnotation: annotationList[0],
                });

                const scrollElement =
                  document.getElementById("webViewerReference");
                let scrollTop = scrollElement.scrollTop + 30 || 0;

                if (
                  selectedReference &&
                  !this.props.approved &&
                  !this.props.readOnly
                ) {
                  var modal = {
                    dataElement: "referenceLabellerCustomModalContainer",
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,

                    render: function renderCustomModal() {
                      let referenceLabellerContainer = document.getElementById(
                        "referenceLabellerContainer"
                      );
                      referenceLabellerContainer.style.left = "52%";
                      referenceLabellerContainer.style.top =
                        annotationList[0].getY() *
                          instance.Core.documentViewer.getZoomLevel() +
                        scrollTop +
                        "px";

                      let referenceDocumentLabelInput = document.getElementById(
                        "referenceDocumentLabelInput"
                      );
                      referenceDocumentLabelInput.value =
                        selectedReference.document.reference_document_label;

                      let referenceLabelInput = document.getElementById(
                        "referenceLabelInput"
                      );
                      referenceLabelInput.value = selectedReference.label;

                      referenceLabellerContainer.style.display = "table";
                    },
                  };
                  instance.UI.addCustomModal(modal);
                  instance.UI.openElements([modal.dataElement]);
                } else if (
                  !this.props.approved &&
                  !this.props.readOnly &&
                  !selectedReference
                ) {
                  await PDFNet.initialize();
                  const doc = await documentViewer.getDocument().getPDFDoc();
                  const page = await doc.getPage(
                    annotationList[0].getPageNumber()
                  );
                  const rect = await page.getCropBox();
                  const te = await PDFNet.TextExtractor.create();
                  te.begin(page, rect);
                  const numAnnots = await page.getNumAnnots();
                  let annotationText;
                  for (let i = 0; i < numAnnots; ++i) {
                    const annot = await page.getAnnot(i);
                    const annotRect = await annot.getRect();
                    const selectedAnnotRect = await annotationList[0].getRect();
                    if (
                      Math.floor(annotRect.x1) ===
                        Math.floor(selectedAnnotRect.x1) &&
                      Math.floor(annotRect.x2) ===
                        Math.floor(selectedAnnotRect.x2)
                    ) {
                      const textData = await te.getTextUnderAnnot(annot);
                      annotationText = textData;
                    }
                  }

                  let pageRefCount = 0;
                  let referenceDocumentLabel = _that.state
                    .referenceDocumentLabel
                    ? _that.state.referenceDocumentLabel
                    : _that.props.referenceDocumentLabel;
                  _that.props.references.map((ref) => {
                    if (
                      ref.page.page_number === annotationList[0].getPageNumber()
                    ) {
                      pageRefCount += 1;
                    }
                  });

                  const letterSequence =
                    pageRefCount < 26
                      ? numberToEncodedLetter(pageRefCount + 1)
                      : numberToEncodedLetter(pageRefCount);
                  const referenceLabel = `pg${annotationList[0].getPageNumber()} ${letterSequence}`;

                  _that.setState({
                    referenceLabel,
                    referenceDocumentLabel,
                    creatingNewAnnotation: true,
                    currentPageIndex: annotationList[0].getPageNumber(),
                    externalAnnotationSelected: true,
                    currentAnnotationText: annotationText,
                  });
                  renderLabellerModal(
                    annotationList[0].getY(),
                    scrollTop,
                    referenceDocumentLabel,
                    referenceLabel
                  );
                }

                // Trigger comment panel in parent DocumentViewer.
                _that.props.onAnnotationSelect(pageIndex, annotationId);
              }
            }
          }
        );

        this.setState({ webViewerLoaded: true });
      });
  };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.references[0]) {
      this.setState({
        referenceDocumentLabel:
          nextProps.references[0].document.reference_document_label,
      });
    }

    if (
      nextProps.hideOutsideAnnotations !== this.props.hideOutsideAnnotations
    ) {
      if (nextProps.hideOutsideAnnotations) {
        this.hideExternalAnnots();
      } else {
        this.showExternalAnnots();
      }
    }

    if (
      nextProps.hideReferenceAnnotations !== this.props.hideReferenceAnnotations
    ) {
      if (nextProps.hideReferenceAnnotations) {
        this.hideReferenceAnnots();
      } else {
        this.showReferenceAnnots();
      }
    }
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
    let i = window.WebViewer.getInstance(
      document.getElementById("webViewerReference")
    );
    i.UI.closeDocument();
    i.UI.dispose();
  }

  hideExternalAnnots = () => {
    const annots = this.state.outsideAnnotations;
    annots.map((annot) => {
      if (annot) {
        this.annotationManager.hideAnnotation(annot);
      }
    });
  };

  showExternalAnnots = () => {
    const annots = this.state.outsideAnnotations;
    annots.map((annot) => {
      if (annot) {
        this.annotationManager.showAnnotation(annot);
      }
    });
  };

  hideReferenceAnnots = () => {
    const annots = this.state.referenceAnnotations;
    annots.map((annot) => {
      if (annot) {
        this.annotationManager.hideAnnotation(annot);
      }
    });
  };

  showReferenceAnnots = () => {
    const annots = this.state.referenceAnnotations;
    annots.map((annot) => {
      if (annot) {
        this.annotationManager.showAnnotation(annot);
      }
    });
  };

  deselectReference = () => {
    this.documentViewer.clearSelection();
    this.annotationManager.deselectAllAnnotations();
  };

  confirmExistingReference = () => {
    const referenceDocumentLabel = this.state.referenceDocumentLabel;
    const annotation = this.annotationManager.getAnnotationById(
      this.state.selectedReferenceAnnotationId
    );

    this.props.onAddReference(
      annotation.PageNumber - 1,
      annotation.Id,
      null,
      null,
      this.state.referenceLabel,
      referenceDocumentLabel
    );
  };

  confirmReference = async () => {
    if (this.state.externalAnnotationSelected) {
      const referenceDocumentLabel = this.state.referenceDocumentLabel;
      const annotation = this.annotationManager.getAnnotationById(
        this.state.selectedReferenceAnnotationId
      );

      this.updateHighlightColor(annotation);

      this.annotationManager
        .exportAnnotationCommand([annotation])
        .then((xfdf) => {
          this.props.onAddReference(
            annotation.PageNumber,
            annotation.Id,
            xfdf,
            this.state.currentAnnotationText,
            this.state.referenceLabel,
            referenceDocumentLabel
          );
        });
    } else if (this.state.pinDropReferenceCreated) {
      const referenceDocumentLabel = this.state.referenceDocumentLabel;

      const annotation = this.annotationManager.getAnnotationById(
        this.state.createdPinDropAnnotation.Id
      );

      // this.annotationManager
      // .exportAnnotationCommand([annotation])
      // .then((xfdf) => {
      this.props.onAddReference(
        annotation.PageNumber,
        annotation.Id,
        this.state.currentAnnotationXfdf,
        this.state.currentAnnotationText,
        this.state.referenceLabel,
        referenceDocumentLabel
      );
      // })
      // .then(() => {
      this.setState({
        pinDropReferenceCreated: false,
      });
      // });
    } else {
      const selectedTextQuads =
        this.documentViewer.getSelectedTextQuads()[this.state.currentPageIndex];

      // When editing an existing reference (e.g. changing its annotation ID)
      // there is no active text selection, so getSelectedTextQuads() returns
      // nothing for the current page. Creating a new TextHighlightAnnotation
      // here would assign an empty/undefined Quads array, which throws
      // "Argument quads requires an array of at least one element". The
      // annotation already exists in those cases, so there is nothing to
      // create — bail out instead of building a new highlight.
      const hasSelectedTextQuads =
        Array.isArray(selectedTextQuads) && selectedTextQuads.length > 0;
      if (!hasSelectedTextQuads) {
        return;
      }

      const highlight =
        new this.instance.Core.Annotations.TextHighlightAnnotation();

      highlight.PageNumber = this.state.currentPageIndex;
      highlight.StrokeColor = new this.instance.Core.Annotations.Color(
        122,
        106,
        141
      );
      highlight.FillColor = new this.instance.Core.Annotations.Color(
        122,
        106,
        141
      );
      highlight.Quads = selectedTextQuads;
      highlight.Opacity = 0.5;
      highlight.BlendMode = "normal";

      this.instance.Core.annotationManager.addAnnotation(highlight);
      this.instance.Core.annotationManager.drawAnnotations(
        highlight.PageNumber
      );
    }
  };

  hideLabellerModal = () => {
    this.setState({
      creatingNewAnnotation: false,
    });

    let refDocLabelExistsError = document.getElementById(
      "refDocLabelExistsError"
    );
    refDocLabelExistsError.style.display = "none";

    let refLabelError = document.getElementById("refLabelError");
    refLabelError.style.display = "none";

    const refLabelEmptyError = document.getElementById("refLabelEmptyError");
    refLabelEmptyError.style.display = "none";

    let refDocLabelError = document.getElementById("refDocLabelError");
    refDocLabelError.style.display = "none";

    this.instance.UI.closeElements(["referenceLabellerCustomModalContainer"]);

    let referenceLabellerContainer = document.getElementById(
      "referenceLabellerContainer"
    );
    referenceLabellerContainer.style.display = "none";

    this.closeChangeSubmission(false, true);
  };

  handleChangeSubmission = () => {
    let referenceDocumentLabelInput = document.getElementById(
      "referenceDocumentLabelInput"
    );
    let referenceDocumentLabel = referenceDocumentLabelInput.value;

    let referenceLabelInput = document.getElementById("referenceLabelInput");
    let referenceLabel = referenceLabelInput.value;

    let selectedRefId = "";

    this.props.references.map((ref) => {
      if (ref.xfdf_highlight_id === this.state.selectedReferenceAnnotationId) {
        selectedRefId = ref.id;
      }
    });

    if (this.state.creatingNewAnnotation) {
      selectedRefId = this.props.references[0].id;
      referenceLabel = this.props.references[0].label;
      this.props.onUpdateReferenceLabel(
        selectedRefId,
        referenceLabel,
        referenceDocumentLabel
      );
    } else {
      this.props.onUpdateReferenceLabel(
        selectedRefId,
        referenceLabel,
        referenceDocumentLabel
      );
    }

    this.setState({ editAnnotationLabelOpen: false });
    this.closeChangeSubmission(true);
  };

  closeChangeSubmission = (
    valuesUpdated = false,
    enableRefDocLabelInput = false
  ) => {
    let referenceDocumentLabel = this.state.referenceDocumentLabel;

    if (!valuesUpdated) {
      referenceDocumentLabel =
        this.props.references[0] !== undefined
          ? this.props.references[0].document.reference_document_label
          : null;
    }
    let refDocLabelPencilIcon = document.getElementById(
      "refDocLabelPencilIcon"
    );
    refDocLabelPencilIcon.style.display = "block";

    let refLabelCheckmark = document.getElementById("refLabelCheckmark");
    refLabelCheckmark.style.display = "none";

    let refDocLabelCheckmark = document.getElementById("refDocLabelCheckmark");
    refDocLabelCheckmark.style.display = "none";

    let referenceDocumentLabelInput = document.getElementById(
      "referenceDocumentLabelInput"
    );
    referenceDocumentLabelInput.value = referenceDocumentLabel;
    referenceDocumentLabelInput.disabled = true;
    referenceDocumentLabelInput.style.background = "rgba(234, 235, 239, 1)";
    referenceDocumentLabelInput.style.borderColor = "#D6DCE8";

    if (!this.state.creatingNewAnnotation || enableRefDocLabelInput) {
      let refLabelPencilIcon = document.getElementById("refLabelPencilIcon");
      refLabelPencilIcon.style.display = "block";

      let referenceLabelInput = document.getElementById("referenceLabelInput");
      referenceLabelInput.disabled = true;
      referenceLabelInput.style.background = "rgba(234, 235, 239, 1)";
      referenceLabelInput.style.borderColor = "#D6DCE8";
    }

    let referenceLabellerForm = document.getElementById(
      "referenceLabellerForm"
    );
    referenceLabellerForm.style.display = "flex";

    let refDocLabelConfirmationForm = document.getElementById(
      "refDocLabelConfirmationForm"
    );
    refDocLabelConfirmationForm.style.display = "none";

    this.setState({
      referenceDocumentLabel,
    });
  };

  handleEditRefLabel = () => {
    let pencilIcon = document.getElementById("refLabelPencilIcon");
    pencilIcon.style.display = "none";

    let checkmark = document.getElementById("refLabelCheckmark");
    checkmark.style.display = "block";

    let referenceDocumentLabelInput = document.getElementById(
      "referenceLabelInput"
    );
    referenceDocumentLabelInput.disabled = false;
    referenceDocumentLabelInput.style.background = "white";
    referenceDocumentLabelInput.style.borderColor = "#1b8c96";

    this.setState({ editAnnotationLabelOpen: true });
  };

  handleEditRefDocLabel = () => {
    let pencilIcon = document.getElementById("refDocLabelPencilIcon");
    pencilIcon.style.display = "none";

    let checkmark = document.getElementById("refDocLabelCheckmark");
    checkmark.style.display = "block";

    let referenceDocumentLabelInput = document.getElementById(
      "referenceDocumentLabelInput"
    );
    referenceDocumentLabelInput.disabled = false;
    referenceDocumentLabelInput.style.background = "white";
    referenceDocumentLabelInput.style.borderColor = "#1b8c96";

    this.setState({ editReferenceLabelOpen: true });
  };

  handleConfirmRefDocLabel = () => {
    if (this.validateInput()) {
      let referenceLabellerForm = document.getElementById(
        "referenceLabellerForm"
      );
      referenceLabellerForm.style.display = "none";
      this.setState({ editReferenceLabelOpen: false });

      let confirmationForm = document.getElementById(
        "refDocLabelConfirmationForm"
      );
      confirmationForm.style.display = "flex";
    }
  };

  handleConfirmRefLabel = () => {
    if (this.validateInput()) {
      this.handleChangeSubmission();
    }
  };

  render() {
    return (
      <div className={styles.webViewerContainer} id="webViewerContainer">
        <div
          id="webViewerReference"
          className={styles.webViewer}
          ref={this.viewer}
        ></div>
        <div
          id="referenceLabellerContainer"
          className={styles.referenceLabellerContainer}
        >
          <form
            id="referenceLabellerForm"
            className={styles.refLabelForm}
            onSubmit={this.handleSave}
          >
            <div className={styles.toolTipContainer}>
              <div className={styles.refIdTooltipBox}>
                <Tooltip type="description" subType="referenceId" />
              </div>
            </div>
            <label className={styles.refLabelFormLabel}>
              <div className={styles.labelContainer}>
                <div className={styles.refLabel}>reference id</div>
              </div>
              <div className={styles.inputContainer}>
                <input
                  className={styles.refLabelInput}
                  disabled={true}
                  placeholder="ie: Author and Year"
                  id="referenceDocumentLabelInput"
                  name="referenceDocumentLabel"
                  type="text"
                  onChange={this.handleChange}
                />
                <img
                  id="refDocLabelPencilIcon"
                  className={styles.pencil}
                  src={Pencil}
                  onClick={this.handleEditRefDocLabel}
                />
                <img
                  id="refDocLabelCheckmark"
                  className={styles.checkmark}
                  src={GreenCheckmark}
                  onClick={this.handleConfirmRefDocLabel}
                />
              </div>
            </label>
            <div className={styles.toolTipContainer}>
              <div className={styles.annotIdTooltipBox}>
                <Tooltip type="description" subType="annotationId" />
              </div>
            </div>
            <label className={styles.refLabelFormLabel}>
              <div className={styles.labelContainer}>
                <div className={styles.refLabel}>annotation id</div>
              </div>
              <div className={styles.inputContainer}>
                <input
                  className={styles.refLabelInput}
                  disabled={true}
                  id="referenceLabelInput"
                  name="referenceLabel"
                  type="text"
                  onChange={this.handleChange}
                />
                <img
                  id="refLabelPencilIcon"
                  className={styles.pencil}
                  src={Pencil}
                  onClick={this.handleEditRefLabel}
                />
                <img
                  id="refLabelCheckmark"
                  className={styles.checkmark}
                  src={GreenCheckmark}
                  onClick={this.handleConfirmRefLabel}
                />
              </div>
            </label>
            <input
              className={styles.refLabelSubmit}
              type="submit"
              value="Save"
            />
            <span
              className={styles.closeFailedReference}
              onClick={() => this.hideLabellerModal()}
            >
              &times;
            </span>
          </form>
          <div className={styles.labelErrorContainer}>
            <div className={styles.refDocLabelErrorContainer}>
              <span id="refDocLabelError" className={styles.refDocLabelError}>
                Set a reference ID to continue
              </span>
              <span
                id="refDocLabelExistsError"
                className={styles.refDocLabelError}
              >
                This reference ID is taken
              </span>
            </div>
            <div className={styles.refLabelErrorContainer}>
              <span id="refLabelError" className={styles.refLabelError}>
                This annotation ID is taken
              </span>
              <span id="refLabelEmptyError" className={styles.refLabelError}>
                Set an annotation ID to continue
              </span>
            </div>
          </div>
          <div
            id="refDocLabelConfirmationForm"
            className={styles.confirmationForm}
          >
            <div className={styles.confirmationMessageContainer}>
              <h4 className={styles.confirmationTitle}>
                Confirm Reference ID Change
              </h4>
              <p className={styles.confirmationMessage}>
                Are your sure you want to change the Reference ID?
              </p>
            </div>
            <div className={styles.buttonContainer}>
              <UikButton
                className={styles.changeButton}
                onClick={() => this.closeChangeSubmission()}
              >
                Cancel
              </UikButton>
              <UikButton onClick={this.handleChangeSubmission} primary>
                Change
              </UikButton>
            </div>
            <span
              className={styles.closeFailedReference}
              onClick={() => this.closeChangeSubmission()}
            >
              &times;
            </span>
          </div>
        </div>
      </div>
    );
  }
}

PDFTReference.propTypes = {
  doc: PropTypes.object,
  docId: PropTypes.number,
  docExtension: PropTypes.string,
  versionId: PropTypes.number,
  onTextSelection: PropTypes.func,
  onAnnotationSelect: PropTypes.func,
  onAnnotationDeselect: PropTypes.func,
  onAddReference: PropTypes.func,
};

export default PDFTReference;
